module.exports = __webpack_public_path__ + "img/Non-concrete porch_veranda roof attached to main house roof.447676f8.jpg";